// These are only examples, this can be updated...

import colors  from './colors.js';
import metrics from './metrics.js';
import fonts from './fonts.js';

const appStyles = {

  errorText: {
    color: colors.error,
  },

  // ------------------------- INPUT TEXT -------------------------- //

  inputLabel: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.blueLight,
    fontSize: '14px',
    lineHeight: 1,
    fontFamily: 'Lato',
  },
  input: {
    borderWidth: 0,
    borderBottomWidth: 2,
    borderStyle: 'solid',
    borderColor: colors.blue,
    height: '32px',
    lineHeight: '32px',
    fontFamily: 'Lato',
    color: 'rgba(0,0,0,0.65)',
    display: 'block',
    background: 'transparent',
    marginBottom: '20px',
    width: '100%',
    fontSize: fonts.size.medium,
    outline: 'none',
    ':disabled': {
      borderColor: colors.gray,
    },
  },
   inputError: {
    borderWidth: 0,
    borderBottomWidth: 2,
    borderStyle: 'solid',
    borderColor: colors.error,
    height: '32px',
    lineHeight: '32px',
    fontFamily: 'Lato',
    color: 'rgba(0,0,0,0.65)',
    display: 'block',
    background: 'transparent',
    marginBottom: '20px',
    width: '100%',
    fontSize: fonts.size.medium,
    outline: 'none',
  },

  // ------------------------- TEXTAREA -------------------------- //

  textareaLabel: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.blueLight,
    fontSize: '14px',
    lineHeight: 1,
    fontFamily: 'Lato',
  },
  textareaInput: {
    minHeight: '100px',
    border: '1px solid rgba(0,0,0,0.2)',
    borderColor: 'transparent',
    background: 'rgba(255,255,255,.5)',
    marginTop: '20px',
    marginBottom: '20px',
    borderBottom: '2px solid '+colors.blue,
    fontSize: fonts.size.small,
    outline: 'none',
    resize: 'none'
  },

  // ------------------------- SELECT -------------------------- //

  selectLabel: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.blueLight,
    fontSize: '14px',
    lineHeight: 1,
    fontFamily: 'Lato',
  },
  selectInput: {
    color: 'rgba(0,0,0,0.65)',
    border: '1px solid rgba(0,0,0,0.2)',
    borderColor: 'transparent',
    background: 'rgba(255,255,255,.5)',
    marginTop: '20px',
    marginBottom: '20px',
    borderBottom: '2px solid '+colors.blue,
    fontSize: fonts.size.medium,
    outline: 'none',
    fontFamily: 'Lato'
  },

  // ------------------------- BUTTONS -------------------------- //

  greenButton: {
    height: '55px',
    display: 'inline-block',
    backgroundColor: colors.green,
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.24)',
    borderRadius: '100px',
    fontFamily: 'Lato',
    fontSize: '16px',
    textAlign: 'center',
    lineHeight: '55px',
    color: 'rgba(255,255,255,0.87)',
    borderWidth: 0,
    marginTop: 10,
    marginBottom: 10,
    cursor: 'pointer',
  },
  facebookButton: {
    height: '55px',
    display: 'inline-block',
    backgroundColor: colors.blueFacebook,
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.24)',
    borderRadius: '100px',
    fontFamily: 'Lato',
    fontSize: '16px',
    textAlign: 'center',
    lineHeight: '55px',
    color: 'rgba(255,255,255,0.87)',
    borderWidth: 0,
    marginTop: 10,
    marginBottom: 10,
    cursor: 'pointer',
    backgroundImage: 'url(/assets/images/facebook.png)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 23px center',
    padding: '1px 10px 1px 26px',
  },
  googleButton: {
    height: '55px',
    display: 'inline-block',
    backgroundColor: colors.redGoogle,
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.24)',
    borderRadius: '100px',
    fontFamily: 'Lato',
    fontSize: '16px',
    textAlign: 'center',
    lineHeight: '55px',
    color: 'rgba(255,255,255,0.87)',
    borderWidth: 0,
    marginTop: 10,
    marginBottom: 10,
    cursor: 'pointer',
    backgroundImage: 'url(/assets/images/google.png)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 23px center',
    padding: '1px 10px 1px 30px',
  },
  blueButton: {
    backgroundColor: colors.blue,
    color: colors.white,
    fontSize: fonts.size.small,
    borderRadius: metrics.radius.tiny,
    margin: metrics.margin.medium,
    outline: 'none',
		border: 'none',
		padding: '10px',
		cursor: 'pointer',
		boxShadow: '0 0 4px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.24)',
	},
  grayButton: {
    backgroundColor: colors.gray,
    color: colors.white,
    fontSize: fonts.size.small,
    borderRadius: metrics.radius.tiny,
    margin: metrics.margin.medium,
    outline: 'none',
		border: 'none',
		padding: '10px',
		cursor: 'pointer',
		boxShadow: '0 0 4px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.24)',
	},
  menuButton: {
    height: '55px',
    display: 'inline-block',
    backgroundColor: colors.green,
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.24)',
    borderRadius: '100px',
    fontFamily: 'Lato',
    fontSize: '16px',
    textAlign: 'center',
    lineHeight: '55px',
    color: 'rgba(255,255,255,0.87)',
    borderWidth: 0,
    marginTop: 10,
    marginBottom: 10,
    cursor: 'pointer',
  },

}

export default appStyles;



// WEBPACK FOOTER //
// ./src/theme/appStyles.js